import {
  Apple,
  Bird,
  Carrot,
  Cat,
  Cherry,
  Citrus,
  Dog,
  Fish,
  Flower2,
  Grape,
  Leaf,
  Rabbit,
  Snail,
  Sprout,
  TreePine,
  Turtle,
  Wheat,
} from 'lucide-react';

export const SAFE_AVATAR_PREFIX = 'eva-avatar:';

export const AVATAR_OPTIONS = [
  { id: 'apple', label: 'Apple', Icon: Apple, bgClass: 'bg-red-50 dark:bg-red-950/40', textClass: 'text-red-500' },
  { id: 'cherry', label: 'Cherry', Icon: Cherry, bgClass: 'bg-rose-50 dark:bg-rose-950/40', textClass: 'text-rose-500' },
  { id: 'citrus', label: 'Citrus', Icon: Citrus, bgClass: 'bg-orange-50 dark:bg-orange-950/40', textClass: 'text-orange-500' },
  { id: 'grape', label: 'Grape', Icon: Grape, bgClass: 'bg-violet-50 dark:bg-violet-950/40', textClass: 'text-violet-500' },
  { id: 'leaf', label: 'Leaf', Icon: Leaf, bgClass: 'bg-emerald-50 dark:bg-emerald-950/40', textClass: 'text-emerald-500' },
  { id: 'sprout', label: 'Sprout', Icon: Sprout, bgClass: 'bg-lime-50 dark:bg-lime-950/40', textClass: 'text-lime-600 dark:text-lime-400' },
  { id: 'tree-pine', label: 'Pine Tree', Icon: TreePine, bgClass: 'bg-teal-50 dark:bg-teal-950/40', textClass: 'text-teal-600 dark:text-teal-400' },
  { id: 'flower', label: 'Flower', Icon: Flower2, bgClass: 'bg-fuchsia-50 dark:bg-fuchsia-950/40', textClass: 'text-fuchsia-500' },
  { id: 'wheat', label: 'Wheat', Icon: Wheat, bgClass: 'bg-amber-50 dark:bg-amber-950/40', textClass: 'text-amber-500' },
  { id: 'bird', label: 'Bird', Icon: Bird, bgClass: 'bg-sky-50 dark:bg-sky-950/40', textClass: 'text-sky-500' },
  { id: 'fish', label: 'Fish', Icon: Fish, bgClass: 'bg-cyan-50 dark:bg-cyan-950/40', textClass: 'text-cyan-500' },
  { id: 'rabbit', label: 'Rabbit', Icon: Rabbit, bgClass: 'bg-stone-100 dark:bg-stone-900/60', textClass: 'text-stone-500 dark:text-stone-300' },
  { id: 'cat', label: 'Cat', Icon: Cat, bgClass: 'bg-purple-50 dark:bg-purple-950/40', textClass: 'text-purple-500' },
  { id: 'dog', label: 'Dog', Icon: Dog, bgClass: 'bg-yellow-50 dark:bg-yellow-950/40', textClass: 'text-yellow-600 dark:text-yellow-400' },
  { id: 'turtle', label: 'Turtle', Icon: Turtle, bgClass: 'bg-green-50 dark:bg-green-950/40', textClass: 'text-green-600 dark:text-green-400' },
  { id: 'snail', label: 'Snail', Icon: Snail, bgClass: 'bg-slate-100 dark:bg-slate-900/60', textClass: 'text-slate-500 dark:text-slate-300' },
];

export function getAvatarKey(value) {
  if (!value || typeof value !== 'string') return null;
  return value.startsWith(SAFE_AVATAR_PREFIX) ? value.slice(SAFE_AVATAR_PREFIX.length) : null;
}

export function isSafeAvatar(value) {
  const key = getAvatarKey(value);
  return Boolean(key && AVATAR_OPTIONS.some((avatar) => avatar.id === key));
}

export function toAvatarValue(id) {
  return `${SAFE_AVATAR_PREFIX}${id}`;
}

export function getAvatarOption(value) {
  const key = getAvatarKey(value) || value;
  return AVATAR_OPTIONS.find((avatar) => avatar.id === key) || null;
}

export function getFallbackAvatar(seed = '') {
  const source = String(seed || 'user').toLowerCase();
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = ((hash << 5) - hash + source.charCodeAt(i)) | 0;
  }
  return AVATAR_OPTIONS[Math.abs(hash) % AVATAR_OPTIONS.length];
}
